import {
  Box, Center, Flex, FormLabel, Heading, Stack
} from '@chakra-ui/react';
import InputField from '../InputField';
import { FormStep } from '../MultiStepForm';
import RadioField from '../RadioField';

export default function School(props: { onSubmit: any, validationSchema: any }) {
    const { onSubmit, validationSchema } = props;
    return (
        <FormStep
            stepName="school"
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            <Center>
                <Box w="350px">
                    <Stack align="center">
                        <Heading
                            lineHeight="36px"
                            fontSize="32px"
                            letterSpacing="-0.02em"
                            fontWeight="800"
                            width="470px"
                            textAlign="center"
                        >
                            Where do you go to school?
                        </Heading>
                        <Stack>
                            <FormLabel
                                textAlign="left"
                                mb="-2"
                                mt="4"
                                fontWeight={600}
                                fontSize="15"
                            >
                                University
                            </FormLabel>
                            <InputField name="university" align="center" width="470px" />
                        </Stack>
                        <Stack>
                            <FormLabel
                                textAlign="left"
                                mb="-2"
                                mt="2.5"
                                fontWeight={600}
                                fontSize="15"
                            >
                                Major
                            </FormLabel>
                            <InputField name="major" align="center" width="470px" />
                        </Stack>
                        <Stack mb="24px">
                            <FormLabel
                                textAlign="left"
                                mb="-7"
                                mt="2.5"
                                fontWeight={600}
                                fontSize="15"
                            >
                                Class of...
                            </FormLabel>
                            <Flex gap="8px" alignItems="center" w="470px">
                                <RadioField
                                    name="classOf"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="2022"
                                    text="2022"
                                />
                                <RadioField
                                    name="classOf"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="2023"
                                    text="2023"
                                />
                                <RadioField
                                    name="classOf"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="2024"
                                    text="2024"
                                />
                                <RadioField
                                    name="classOf"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="2025"
                                    text="2025"
                                />
                                <RadioField
                                    name="classOf"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="2026"
                                    text="2026"
                                />
                            </Flex>
                            <RadioField
                                name="classOf"
                                align="center"
                                width="100px"
                                type="radiobutton"
                                value="I'm not in school"
                                text="I'm not in school"
                            />
                        </Stack>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
